export default __webpack_public_path__ + "static/media/welcomeInfo3.56a61fb6.png";